export default __webpack_public_path__ + "static/img-hero-logo-6e80d4c8f9ca596a587d112f856d4390.svg";